module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "ContactUs"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact_banenr"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact_main"
  }, [_c('div', {
    staticClass: "contact_main_title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('contact_us_mainpage_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "contact_main_group"
  }, [_c('div', {
    staticClass: "contact_item1"
  }, [_c('div', {
    staticClass: "tab_content"
  }, [_c('ul', {
    staticClass: "tab_choose"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('secont', $event, 2, 2)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '2' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_hongkong')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('first', $event, 1, 1)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '1' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_guangzhou')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('zero', $event, 0, 7)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '7' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_taiwan')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('third', $event, 3, 3)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '3' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_malaysia')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('fourth', $event, 4, 4)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '4' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_thailand')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('fifth', $event, 5, 5)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '5' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_singapore')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleTab('sixth', $event, 6, 6)
      }
    }
  }, [_c('div', {
    staticClass: "tab-box",
    style: ({
      borderTopColor: _vm.contactId == '6' ? '#0084ff' : '#fff'
    })
  }), _vm._v(_vm._s(_vm.$t('contact_us_company_japan')))])])]), _vm._v(" "), _c('div', {
    staticClass: "contact_main_group"
  }, [_c('div', {
    staticClass: "contact_main_item"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "contact_main_body1"
  }, [_c('p', {
    staticClass: "contact_main_way"
  }, [_vm._v(_vm._s(_vm.$t('contact_way1')) + ":")])]), _vm._v(" "), _vm._m(1, false, false)])]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "contact_main_group"
  }, [_c('div', {
    staticClass: "contact_main_item"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "contact_main_body1"
  }, [_c('p', {
    staticClass: "contact_main_way"
  }, [_vm._v(_vm._s(_vm.$t('contact_way2')) + ":")])]), _vm._v(" "), _vm._m(4, false, false)])])]), _vm._v(" "), _c('div', {
    staticClass: "map_showpace"
  }, [_c(_vm.currentTab, {
    tag: "first",
    attrs: {
      "keep-alive": ""
    }
  })], 1)])]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_main_header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon50_call.png"),
      "width": "40"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_main_body2"
  }, [_c('p', {
    staticClass: "contact_main_answer"
  }, [_vm._v("+852 2473 8888")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_main_group"
  }, [_c('div', {
    staticClass: "contact_main_item"
  }, [_c('div', {
    staticClass: "contact_main_header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/004-whatsapp.png"),
      "width": "40"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact_main_body1"
  }, [_c('p', {
    staticClass: "contact_main_way"
  }, [_vm._v("WhatsApp:")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_main_body2"
  }, [_c('p', {
    staticClass: "contact_main_answer"
  }, [_vm._v("+4474 5204 6699")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_main_header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/wechat.png"),
      "width": "40"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_main_body2"
  }, [_c('p', {
    staticClass: "contact_main_answer"
  }, [_vm._v("IFREEGROUP")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac9a6f9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUs/ContactUs.vue
// module id = 841
// module chunks = 0